import { ReactElement, useMemo } from 'react';
import { QueryAssignmentItem, QueryVehicleManifestItem } from '../../api/schema';
import KPI from '../../component/kpi/KPI';
import { categoryKpiData } from '../../helpers/categoryCounts';

type CategoryCountWidgetProps = {
  items?: (QueryAssignmentItem | QueryVehicleManifestItem)[];
  title?: string;
};

// Product-group counts for remediation equipment, bucketed by product_category
// the same way AssignmentForm's "By Category" KPI does.
export const CategoryCountWidget = ({ items, title = 'Left Onsite' }: CategoryCountWidgetProps): ReactElement => {
  const data = useMemo(() => categoryKpiData(items), [items]);

  return <KPI title={title} background="grey" data={data} />;
};

export default CategoryCountWidget;
